import FakeSearchForm from '@/features/searchV2/modules/FakeSearchForm/FakeSearchForm';
import { classnames, isSistaminuten } from '@/helpers';
import { themed } from '@/helpers/theme';
import useMobileView from '@/hooks/useMobileView';
import { _s, getLang } from '@/locale';

type HeroProps = {
  searchbarContainerRef: React.RefObject<HTMLDivElement>;
  showSearchbar: boolean;
};

const Hero = (props: HeroProps) => {
  const { isMobileView } = useMobileView();
  const selectedLang = getLang();

  return (
    <div
      className={classnames(
        isSistaminuten()
          ? `bg-hero-sm bg-cover bg-bottom bg-no-repeat`
          : `align-center relative flex h-[250px] flex-col justify-end md:h-[394px]`,
      )}>
      {!isSistaminuten() && (
        <picture>
          <source srcSet="/images/desktop-homepage-background-2xl-v7.jpg" media="(min-width: 1900px)" />
          <source srcSet="/images/desktop-homepage-background-lg-v7.jpg" media="(min-width: 768px)" />
          <img
            src="/images/mobile-homepage-background-v7.jpg"
            className="absolute inset-0 h-full w-full bg-[#ddd2e1] object-cover"
            alt=""
          />
        </picture>
      )}
      <div className="container relative z-10 mx-auto">
        <div className={`${themed(!isMobileView ? 'mx-auto max-w-5xl pb-11 pt-20 md:pb-24' : '', 'py-11 md:py-20')}`}>
          {isSistaminuten() && (
            <div className="mb-4 flex">
              <span className="bg-sm_primary mx-auto rounded-full px-6 py-1 text-center font-semibold">
                {_s('40DiscountHome')}
              </span>
            </div>
          )}
          <h1
            className={classnames(
              'md:mb-xxl !mt-0 text-2xl font-semibold md:text-5xl',
              themed('text-white', 'text-black-800'),
              isMobileView
                ? 'max-w-[320px] p-0'
                : `mx-auto ${selectedLang === 'fi' ? 'max-w-[650px]' : 'max-w-[500px]'} text-center`,
              isSistaminuten() && 'my-xl max-w-full text-center',
            )}>
            {isSistaminuten() ? _s('sistaminutenH1') : _s(`bokadirektH1.${isMobileView ? 'mobile' : 'desktop'}`)}
          </h1>
          <div className={classnames(isMobileView ? 'pt-lg pb-xxl' : 'mx-auto max-w-screen-md')}>
            <div ref={props.searchbarContainerRef}></div>
            {props.showSearchbar ? <FakeSearchForm /> : <div className="h-[52px]" />}
          </div>
        </div>
      </div>
      {!isSistaminuten() && <div className="absolute inset-0 bg-black opacity-30 "></div>}
    </div>
  );
};

export default Hero;
